"use client";
import CustomButton, {
  BtnRadius,
  BtnSizes,
  BtnTypes,
} from "@/app/components/lib/CustomButton";
import SvgLikeContained from "../comments/comments-helpers/svgs/SvgLikeContained";
import SvgLikeOutlined from "../comments/comments-helpers/svgs/SvgLikeOutlined";
import { useGetBlogLikeToggleQuery } from "@/api/AppApi/services/blogs";
import { useEffect, useState } from "react";
import { useTranslation } from "@/hooks/localization/useTranslations";

interface props {
  blogSlug: string;
  isLiked: boolean;
}

const BlogLikeBtn: React.FC<props> = ({ blogSlug, isLiked }) => {
  const t = useTranslation();
  const getBlogLikeToggle = useGetBlogLikeToggleQuery({ blogSlug });
  const [liked, setLiked] = useState(isLiked);
  // const liked = getBlogLikeToggle?.data?.result?.liked ?? isLiked;

  const handleLike = () => {
    setLiked((liked) => !liked);
    getBlogLikeToggle?.refetch();
  };
  useEffect(() => {
    if (getBlogLikeToggle?.data?.result)
      setLiked(getBlogLikeToggle?.data?.result?.liked!);
  }, [getBlogLikeToggle?.data?.result]);
  return (
    <CustomButton
      type={liked ? BtnTypes.primary : BtnTypes?.neutral}
      size={BtnSizes.medium}
      radius={BtnRadius.semi_small}
      onClick={handleLike}
    >
      <div className="btn-blog-like">
        {liked ? (
          <>
            <SvgLikeContained large /> {t.liked}
          </>
        ) : (
          <>
            <SvgLikeOutlined large /> {t.like}
          </>
        )}
      </div>
    </CustomButton>
  );
};

export default BlogLikeBtn;
